import { fetch, getIdOrNull } from '..'
import { HttpMethods } from '../apiHelper'
import apiClient from './apiClient'

export const getEvaluationQuestions = (user, institution) => {
  return fetch(
      `/evaluation/questions/${getIdOrNull(institution)}`,
      HttpMethods.GET,
      null,
      user
  )
}

const DEFAULT_PARAM_SAVE_EVALUTATION = { internshipId: -1 }
export const saveEvaluation = (user, data = DEFAULT_PARAM_SAVE_EVALUTATION) => apiClient.patch(user, `api/internships/${data.internshipId}/evaluation-internship`, data)
